<template>
  <div class="card shadow-1 q-px-lg">
    <div style="text-align: start">
      <h3 style="font-size: 20px; gap: 10px" class="flex">
        {{ $gettext('INSTALLMENT_SUMMARY') }}
      </h3>
    </div>
    <div class="sumarryDetailCardContainer">
      <summary-page-detail
        v-if="isDataLoaded"
        title="NEGOTIATION_SUMMARY"
        :forms="negotiantionFormDetail"
        name="negotiationSummary"
        :params="params"
        :parent="this"
        @action-button="actionButtonHandler"
      />
      <summary-page-detail
        v-if="isDataLoaded"
        title="NEGOTIATED_PERIOD"
        :forms="negotiatedFormDetail"
        name="negotiatedPeriod"
        :params="params"
        :parent="this"
        @action-button="actionButtonHandler"
      />
      <summary-page-detail
        v-if="isDataLoaded"
        title="INSTALLMENT_DATA"
        :forms="installmentsFormDetail"
        name="installmentData"
        :params="params"
        :parent="this"
        @action-button="actionButtonHandler"
      />
      <summary-page-detail
        v-if="isDataLoaded"
        title="SIGNATURE_DATA"
        :forms="signatureDataFormDetail"
        name="signatureData"
        :params="params"
        :parent="this"
      />
    </div>

    <div class="flex" style="gap: 10px; width: 100%">
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
const { pageDetail } = JtCrud
import { repository } from 'jtech'
import SummaryPageDetail from './SummaryPageDetail.vue'

@Component({
  name: 'Summary',
  components: { pageDetail, SummaryPageDetail },
  props: {
    data: Object
  }
})
class Summary extends Vue {
  negotiantionFormDetail = {}
  negotiatedFormDetail = {}
  installmentsFormDetail = {}
  signatureDataFormDetail = {}
  isDataLoaded = false

  async mounted () {
    await this.loadFormDetails()
    await this.newMethod()
    this.isDataLoaded = true
  }

  async newMethod () {
    await this.updateFormDetail('invoiceDocumentSummary.pesquisarNegotiationSummary', { agreementInvoiceStatus: this.data.agreementInvoiceStatusId, ...this.negotiantionFormDetail })
    await this.updateFormDetail('invoiceDocumentSummary.pesquisarPeriodSummary', { agreementInvoiceStatus: this.data.agreementInvoiceStatusId, ...this.negotiatedFormDetail })
    await this.updateFormDetail('invoiceDocumentSummary.pesquisarInstallmentsSummary', { agreementInvoiceStatus: this.data.agreementInvoiceStatusId, ...this.installmentsFormDetail })
    await this.updateFormDetail('invoiceDocumentSummary.pesquisarSignatureSummary', { agreementInvoiceStatus: this.data.agreementInvoiceStatusId, ...this.signatureDataFormDetail })
  }

  async updateFormDetail (cfgInterface, formToUpdate) {
    const { registros } = await repository.resolveDatatableModel(cfgInterface, { agreementInvoice: this.data.id, agreementInvoiceStatus: this.data.agreementInvoiceStatusId })
    formToUpdate[0].dadosForm = registros[0]
  }

  async loadFormDetails () {
    const formDetails = await Promise.all([
      this.fetchFormDetail('invoiceDocumentSummary.detalharNegotiationSummary', { id: this.data.id, agreementInvoiceStatus: this.data.agreementInvoiceStatusId }),
      this.fetchFormDetail('invoiceDocumentSummary.detalharPeriodSummary', { id: this.data.id, agreementInvoiceStatus: this.data.agreementInvoiceStatusId }),
      this.fetchFormDetail('invoiceDocumentSummary.detalharInstallmentsSummary', { id: this.data.id, agreementInvoiceStatus: this.data.agreementInvoiceStatusId }),
      this.fetchFormDetail('invoiceDocumentSummary.detalharSignatureSummary', { id: this.data.id, agreementInvoiceStatus: this.data.agreementInvoiceStatusId })
    ]);

    [this.negotiantionFormDetail, this.negotiatedFormDetail, this.installmentsFormDetail, this.signatureDataFormDetail] = formDetails.map(detail => {
      return [detail]
    })
  }

  async fetchFormDetail (interfaceName, id) {
    try {
      return await repository.montarTela(interfaceName, { id })
    } catch (error) {
      return { inputs: [], relacionamentos: [], dadosForm: {}, buttons: [] }
    }
  }
}
export default Summary

</script>
<style scoped>
.card {
  height: 100%;
  width: 100%;
}

.sumarryDetailCardContainer {
  display: flex;
  flex-direction: column;
  gap:1rem;
  overflow-y: auto;
  max-height: 500px;
}

.sumarryDetailCard {
  color: black;
  max-width: 800px !important;
  max-height: 300px !important;
}
</style>
